export function initMetaPixel(pixelId: string) {
  if (typeof window === 'undefined') return

  // Avoid loading twice
  if ((window as any).fbq) return

  const f = window as any
  const b = document
  let e: any
  let n: any
  let t: any
  let s: any

  if (f.fbq) return
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  s = b.getElementsByTagName('script')[0]
  s.parentNode?.insertBefore(t, s)

  f.fbq('init', pixelId)
  f.fbq('track', 'PageView')
}
